/**
 * @flow weak
 */

import { createStructuredSelector } from 'reselect';

// Raw Selector
export const stripeProviderKey = (state) => state.stripe.providerKey;
export const stripeCardInstance = (state) => state.stripe.cardInstance;
export const stripeCardConfig = (state) => state.stripe.config;
export const stripeInstance = (state) => state.stripe.stripeInstance;
export const isValidStripeCard = (state) => state.stripe.completed;

// Connector
export default createStructuredSelector({
  stripeProviderKey,
  stripeCardInstance,
  stripeCardConfig,
  stripeInstance,
  isValidStripeCard
});



// WEBPACK FOOTER //
// ./src/modules/stripe/getters.js